/* eslint-disable no-lonely-if */
/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-template */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';

/**
 * フリーキャラクターテキストアイテム入力dilaogクラス
 */
export default class PinTextInput3DDialog extends Dialog {
  guid: string = '';

  openCallback: Function = undefined;

  closeCallback: Function = undefined;

  mode: string = 'view';

  item: marietta.webcad.item.MonicaObject|null;

  /**
    * コンストラクタ
  */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    // ダイアログのコンテンツ生成
    const id:string = 'pintTextInput3DDialog';
    // タイトル
    let title:string = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'ピンテキスト'; break;
      default: title = 'Pin text'; break;
    }
    this.item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(this.guid);
    let text = '';
    let linkName = '';
    let linkUrl = '';
    if (this.item) {
      text = (this.item as marietta.webcad.item.MonicaObject).itemInfo.text;
      if (this.item.itemInfo.link) {
        if (this.item.itemInfo.link.length > 0) {
          linkName = this.item.itemInfo.link[0].name;
          linkUrl = this.item.itemInfo.link[0].url;
        }
      }
    }
    let contents:string = '<div class="dialogPinTextInput3D">\n';
    contents += '<div class="dialogBodyInner">\n';
    contents += '<div class="pinTextWrap">\n';
    contents += '<div class="viewContainer viewMode">\n';
    contents += '<div class="linkUrlView" id="pinLinkUrlWrapContainer">\n';
    if (linkUrl) {
      if (marietta.WebCADGlobal.isPinPanoramaItem(this.item.itemInfo.id)) {
        contents += '<div class="linkUrlView"><button id="pinPanoramaUrl3D"><span class="icon icon-link"></span></button></div>';
      } else {
        contents += '<div class="linkUrlView"><a id="pinLinkUrl3D" target="_blank" href="' + linkUrl + '"><span class="icon icon-link"></span></a></div>\n';
      }
    }
    contents += '</div>\n';
    contents += '<div class="textView"><div class="textViewWrap">' + text + '</div></div>\n';
    contents += '</div>\n';
    contents += '<div class="editContainer editMode">\n';
    contents += '<div>';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        contents += '<div class="textWrap"><textarea name="" id="pinTextInputText3D" placeholder="文字を入力してください" value="">' + text + '</textarea></div>';
        break;
      default:
        contents += '<div class="textWrap"><textarea name="" id="pinTextInputText3D" placeholder="please enter text" value="">' + text + '</textarea></div>';
        break;
    }
    contents += '</div>';
    contents += '<div class="linkInsertWrap">';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        contents += '<div class="inputWrap">';
        contents += '<input type="textbox" class="link_textbox" id="link_url_insert_textbox" name="link_url_insert_textbox" placeholder="指定URL" value="' + linkUrl + '">';
        contents += '<div class="btnWrap"><button id="btnGetDoc"><span class="jp">参照</span></button></div>';
        contents += '</div>';
        break;
      default:
        contents += '<div class="inputWrap">';
        contents += '<input type="textbox" class="link_textbox" id="link_url_insert_textbox" name="link_url_insert_textbox" placeholder="Specified URL" value="' + linkUrl + '">';
        contents += '<div class="btnWrap"><button id="btnGetDoc"><span class="en">Reference</span></button></div>';
        contents += '</div>';
        break;
    }
    contents += '<div class="docBtnWarap"><div class="error_msg editMode"></div></div>';
    contents += '</div>';
    contents += '</div>\n';
    contents += '</div>\n';
    contents += '</div>\n';
    contents += '</div>';
    let footer:string = '';
    footer += '<button class="viewMode" id="btnEditPin3D"><span class="jp">編集</span><span class="en">Edit</span></button>';
    footer += '<button class="editMode" id="btnDoneTextInput"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnCancelTextInput"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);
    (<HTMLButtonElement>document.getElementById('btnCancelTextInput')).onclick = (e: Event) => {
      this.btnCancelHandler(e);
    };
    (<HTMLButtonElement>document.getElementById('btnEditPin3D')).onclick = (e: Event) => {
      this.btnEditHandler(e);
    };
    if (document.getElementById('btnGetDoc')) {
      document.getElementById('btnGetDoc').onclick = (e: Event) => this.btnGetDocHandler(e);
    }
    if (this.openCallback != null) {
      this.openCallback();
    }

    document.getElementById('pinPanoramaUrl3D')?.addEventListener('click', () => (this.item as marietta.webcad.item.PinPanorama)?.panoramaView());
  }

  /**
   * ドキュメント データ イベント ハンドラを取得する
   * @return void
   * @param e => mouse event
   */
  protected btnGetDocHandler = (e: any) => {
    e.preventDefault();

    if (marietta.WebCADGlobal.isPinPanoramaItem(this.item.itemInfo.id)) {
      marietta.webcad.manager.APIManager.selectPlanningDocument(this.appendDocument);
      return;
    }

    marietta.webcad.manager.APIManager.selectPictureDocument( this.appendDocument );
  }

  public appendDocument(checkedList = []) {
    if (checkedList.length > 0) {
      (<HTMLInputElement>document.getElementById('link_url_insert_textbox')).value = checkedList[0].file_path;
      // (<HTMLInputElement>document.getElementById('link_name_insert_textbox')).value = checkedList[0].file_name;
    }
  }

  updateView() {
    if (this.mode === 'edit') {
      const viewModeElem = (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('viewMode');
      for (let i = 0; i < viewModeElem.length; i += 1) {
        (viewModeElem[i] as HTMLElement).style.display = 'none';
      }
      const editModeElem = (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('editMode');
      for (let i = 0; i < editModeElem.length; i += 1) {
        (editModeElem[i] as HTMLElement).style.display = 'inline-block';
      }
      (<HTMLButtonElement>document.getElementById('btnDoneTextInput')).onclick = (e: Event) => this.btnDoneHandler(e);
    } else {
      const editModeElem = (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('editMode');
      for (let i = 0; i < editModeElem.length; i += 1) {
        (editModeElem[i] as HTMLElement).style.display = 'none';
      }
      const viewModeElem = (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('viewMode');
      for (let i = 0; i < viewModeElem.length; i += 1) {
        (viewModeElem[i] as HTMLElement).style.display = 'inline-block';
      }
    }
  }

  /**
   *
   * @return void
   * @param e => mouse event
  */
  btnEditHandler = (e: any) => {
    e.preventDefault();
    this.mode = 'edit';
    this.updateView();
  }

  /**
   * OKボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnDoneHandler = (e: any) => {
    e.preventDefault();
    let textErrorMsg = '';
    let linkErrorMsg = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        textErrorMsg = '文字を入力してください。';
        linkErrorMsg = '指定のURLを入力してください。';
        break;
      default:
        textErrorMsg = 'Please enter input text';
        linkErrorMsg = 'please enter specified URL.';
        break;
    }

    const textAreaVal = (<HTMLInputElement>document.getElementById('pinTextInputText3D')).value;
    const linkName = '';
    const linkUrl = (<HTMLInputElement>document.getElementById('link_url_insert_textbox')).value.trim();
    let errorMsg = '';
    if (textAreaVal === '' && linkUrl === '') {
      errorMsg = textErrorMsg;
    }
    if (errorMsg) {
      // エラーメッセージ表示
      (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('error_msg')[0].innerHTML = errorMsg;
    } else {
      (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('error_msg')[0].innerHTML = '';
      (this.item as marietta.webcad.item.MonicaObject).itemInfo.text = textAreaVal;
      if (linkUrl) {
        this.item.itemInfo.link = [{ name: linkName, url: linkUrl }];
      } else {
        this.item.itemInfo.link = [];
      }
      this.item.reCreateImage();
      let textArray: string[] = [];
      if (textAreaVal.indexOf('\n') !== -1) {
        textArray = textAreaVal.split('\n');
      } else {
        textArray[0] = textAreaVal;
      }
      const text = textArray.join('<br>');
      (<HTMLElement>document.getElementById('pintTextInput3DDialog')).getElementsByClassName('textViewWrap')[0].innerHTML = text;

      if (marietta.WebCADGlobal.isPinPanoramaItem(this.item.itemInfo.id)) {
        this.mode = 'view';
        this.updateView();
        return;
      }

      if (document.getElementById('pinLinkUrl3D')) {
        if (linkUrl) {
          (<HTMLElement>document.getElementById('pinLinkUrl3D')).setAttribute('href', linkUrl);
        } else {
          (<HTMLElement>document.getElementById('pinLinkUrlWrapContainer')).innerHTML = '';
        }
      } else {
        if (linkUrl) {
          (<HTMLElement>document.getElementById('pinLinkUrlWrapContainer')).innerHTML = '<div class="linkUrlView"><a id="pinLinkUrl3D" target="_blank" href="' + linkUrl + '"><span class="icon icon-link"></span></a></div>';
        }
      }
      this.mode = 'view';
      this.updateView();
    }
  }

  /**
   * Cancelボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnCancelHandler = (e: any) => {
    e.preventDefault();
    if (this.mode === 'edit') {
      this.mode = 'view';
      this.updateView();
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
      // パネルを閉じる
      this.close();
    }
  }

  /**
  * 閉じるボタンが押された
  */
  close = () => {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    this.closeEvent();

    if (this.closeCallback != null) {
      this.closeCallback();
    }
  }
}
